import { breakpoints, styled } from 'styles';

export const Container = styled.div`
  font-size: 1.6rem;
  padding: 12px 0;
  line-height: 1;
  background: #024781;
  color: #fff;

  p {
    flex: 1;
    line-height: 1.4;
    margin: 0 10px;

    @media (max-width: ${breakpoints.md}) {
      margin: 0 15px;
    }
  }

  b {
    font-weight: 600;
  }

  a {
    opacity: 0.75;
    padding-top: 2px;
    margin-right: -3px;
    cursor: pointer;

    &:hover {
      opacity: 1;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
